import { useEffect, useRef } from "react";
import { RoadEngine } from "@/game/space/roadEngine";

// Live (non-recording) RoadEngine player for the PvP arena battle animation.
// Runs the 3-lane squad advance on autopilot for `durationMs`, then calls onDone.
export default function ArenaBattleCanvas({ sprites, backdrop, barrelStyle = "steel", durationMs = 5000, onDone }) {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    let engine = null; let done = false; let hard = null;
    const finish = () => { if (done) return; done = true; clearTimeout(hard); try { engine?.unmount(); } catch { /* noop */ } onDone?.(); };
    const raf = requestAnimationFrame(() => {
      try {
        engine = new RoadEngine(canvas, {
          sprites: sprites || {}, macro: "forward", speed: 80, spawnRule: "BLITZ",
          bgFull: !!backdrop, barrelStyle, autopilot: true, durationMs,
          onFinish: finish, onGameOver: finish,
        });
        if (backdrop) engine.setBackdrop(backdrop);
        engine.mount();
        hard = setTimeout(finish, durationMs + 1000);
      } catch (e) { finish(); }
    });
    return () => { cancelAnimationFrame(raf); clearTimeout(hard); try { engine?.unmount(); } catch { /* noop */ } };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <canvas ref={ref} className="w-full h-full block" data-testid="pvp-arena-battle-canvas" />;
}
